import React, { forwardRef } from 'react';
import MappingFormWithApplicationId from '../common/MappingFormWithApplicationId';

const QwietAIMappingForm = forwardRef((props, ref) => {
  return <MappingFormWithApplicationId ref={ref} {...props} />;
})

export default QwietAIMappingForm;